import { defineMessages } from "react-intl";

export const INTERNATIONALIZED_PRODUCT_LABELS = defineMessages({
  "mapka_pro_account_user.name": {
    id: "mapka_pro_account_user.name",
    defaultMessage: "Team seats",
  },
  "mapka_pro_account_user.description": {
    id: "mapka_pro_account_user.description",
    defaultMessage: "Collaborate with your team. Add unlimited users to your account.",
  },
  "mapka_pro_custom_tileset.name": {
    id: "mapka_pro_custom_tileset.name",
    defaultMessage: "Custom tilesets",
  },
  "mapka_pro_custom_tileset.description": {
    id: "mapka_pro_custom_tileset.description",
    defaultMessage: "Upload and host your own vector or raster tilesets.",
  },
  "mapka_pro_custom_style.name": {
    id: "mapka_pro_custom_style.name",
    defaultMessage: "Custom maps",
  },
  "mapka_pro_custom_style.description": {
    id: "mapka_pro_custom_style.description",
    defaultMessage: "Create unique map styles with our visual editor.",
  },
  "mapka_pro_map_session.name": {
    id: "mapka_pro_map_session.name",
    defaultMessage: "Map loads",
  },
  "mapka_pro_map_session.description": {
    id: "mapka_pro_map_session.description",
    defaultMessage: "Each time a user loads a map, we count it as a map load.",
  },
  "mapka_pro_storage.unitLabel": {
    id: "mapka_pro_storage.unitLabel",
    defaultMessage: "GB",
  },
  "mapka_pro_storage.name": {
    id: "mapka_pro_storage.name",
    defaultMessage: "Data storage",
  },
  "mapka_pro_storage.description": {
    id: "mapka_pro_storage.description",
    defaultMessage: "Secure cloud storage for your data.",
  },
  "mapka_pro_tile_usage.name": {
    id: "mapka_pro_tile_usage.name",
    defaultMessage: "Tile API requests",
  },
  "mapka_pro_tile_usage.description": {
    id: "mapka_pro_tile_usage.description",
    defaultMessage: "Serve map tiles via our high-performance global CDN.",
  },
  "mapka_pro_processing.name": {
    id: "mapka_pro_processing.name",
    defaultMessage: "Data processing",
  },
  "mapka_pro_processing.description": {
    id: "mapka_pro_processing.description",
    defaultMessage: "Transform and process geospatial data",
  },
  "mapka_pro_input_token.name": {
    id: "mapka_pro_input_token.name",
    defaultMessage: "Input tokens",
  },
  "mapka_pro_input_token.description": {
    id: "mapka_pro_input_token.description",
    defaultMessage: "Power AI-assisted map generation with natural language prompts.",
  },
  "mapka_pro_output_token.name": {
    id: "mapka_pro_output_token.name",
    defaultMessage: "Output tokens",
  },
  "mapka_pro_output_token.description": {
    id: "mapka_pro_output_token.description",
    defaultMessage: "Power AI-assisted map generation with natural language prompts.",
  },
});

export const INTERNATIONALIZED_UNIT_LABELS = defineMessages({
  "token": {
    id: "unit.token",
    defaultMessage: "million tokens",
  },
  "GB": {
    id: "unit.GB",
    defaultMessage: "GB",
  },
  "minute": {
    id: "unit.minute",
    defaultMessage: "minute",
  },
  "1000_requests": {
    id: "unit.1000_requests",
    defaultMessage: "1000 requests",
  },
  "tileset": {
    id: "unit.tileset",
    defaultMessage: "tileset",
  },
  "team_member": {
    id: "unit.seat",
    defaultMessage: "team member",
  },
  "map": {
    id: "unit.map",
    defaultMessage: "map",
  },
});
